import {Suspense} from 'react'
import type {ConnectedProps} from 'react-redux'
import {connect} from 'react-redux'

import {openDialog} from '../../../../../actions'
import type {State} from '../../../../../reducers/types'
import {getBuild, getBuildType} from '../../../../../selectors'
import type {BuildType} from '../../../../../services/rest'
import type {BuildId, NormalizedBuild} from '../../../../../types'

import PinBuild from './PinBuild'

type Props = {
  buildId: BuildId
}

const mapStateToProps = (state: State, props: Props) => {
  const build: Partial<NormalizedBuild> = getBuild(state, props.buildId) || {}
  const {pinned, pinInfo} = build
  const buildType: Partial<BuildType> = getBuildType(state, build.buildType) || {}
  const {projectId} = buildType
  return {
    projectId,
    buildTypeId: buildType.id,
    isFinishedBuild: build.state === 'finished',
    isPinned: pinned,
    pinCommentText: pinInfo?.text,
    pinCommentTimestamp: pinInfo?.timestamp,
    pinCommentUser: pinInfo?.user,
  }
}

const actionCreators = {
  openDialog,
}

const connector = connect(mapStateToProps, actionCreators)

export default connector(function PinBuildContainer(
  props: Props & ConnectedProps<typeof connector>,
) {
  return (
    <Suspense>
      <PinBuild {...props} />
    </Suspense>
  )
})
